module.exports = __webpack_public_path__ + "static/media/amusement(8).18bf797d.PNG";